module.exports = __webpack_public_path__ + "img/white-and-pink-floral-freestanding-letter-decor-949586.9e625d08.jpg";